import LayoutLite from "@/components/layouts/layout-lite";
import EventContainer from "@/components/public/event-container";
import OrganizationContainer from "@/components/public/organization-container";

export default function SubdomainSwitcher({ entity }: any) {
  return (
    <LayoutLite
      meta={{
        title:
          entity.data.name +
          " | Tunis events - La billetterie qui vous redonne le contrôle",
        description:
          "Solutions de billetterie et de gestion d'événements pour festivals, clubs, lieux et collectifs. Nous facilitons la vente de billets et la croissance de vos communautés, pour vous concentrer sur la création d'événements exceptionnels.",
        url: "https://tunis.events/pricing",
        image: null,
      }}
    >
      {entity.type == "event" && <EventContainer event={entity.data} />}
      {entity.type == "organization" && (
        <OrganizationContainer
          id="custom-organization-container"
          organization={entity.data}
          includeImage={entity.data?.image ? true : false}
          className="max-w-xl"
        />
      )}
    </LayoutLite>
  );
}

export async function getServerSideProps(context: any) {
  const subdomain = Array.isArray(context.query.subdomain)
    ? context.query.subdomain[0]
    : context.query.subdomain || "";

  let response = await (
    await fetch(process.env.BASE_API_URL + "/public/subdomain/" + subdomain)
  ).json();

  if (response.organization || response.event) {
    return {
      props: {
        entity: {
          type: response.event ? "event" : "organization",
          id: response.event ? response.event.id : response.organization.id,
          data: response.event ? response.event : response.organization,
        },
        messages: (await import(`@/public/i18n/${context.locale}.json`))
          .default,
      },
    };
  } else {
    return {
      redirect: {
        permanent: false,
        destination: "/",
      },
      props: {},
    };
  }
}
